import { Action } from 'redux';
import { GenericBasket, Status } from '@/types';

export enum BasketActionTypes {
  SET_BASKET = '@basket/set',
  SET_BASKET_STATUS = '@basket/set-status',
}

export interface BasketSetStatusAction extends Action {
  type: BasketActionTypes.SET_BASKET_STATUS;
  status: Status;
}

export interface BasketSetAction extends Action {
  type: BasketActionTypes.SET_BASKET;
  payload: GenericBasket;
  status: Status;
}

export type BasketAction = BasketSetAction | BasketSetStatusAction;

export interface BasketState {
  data: GenericBasket;
  status: Status;
}
